module.exports = __webpack_public_path__ + "static/media/robot.082c802d.png";